import { render, staticRenderFns } from "./AccountingDocumentsComponent.vue?vue&type=template&id=cf07d816&"
import script from "./AccountingDocumentsComponent.vue?vue&type=script&lang=js&"
export * from "./AccountingDocumentsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports